<div
  class="fixed inset-0 z-[60] flex items-center justify-center p-4 sm:p-6 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200"
>
  <div
    class="bg-white dark:bg-gray-900 w-full max-w-2xl max-h-[90vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden animate-in zoom-in-95 duration-200"
  >
    <!-- Header -->
    <div
      class="px-6 py-4 border-b border-gray-100 dark:border-gray-800 flex items-center justify-between bg-gray-50/50 dark:bg-gray-800/50"
    >
      <div>
        <h2 class="text-lg font-bold text-gray-900 dark:text-white">Actividad de la Oportunidad</h2>
        <p class="text-sm text-gray-500 dark:text-gray-400 truncate max-w-[400px]">
          {{ dealName }}
        </p>
      </div>
      <button
        (click)="onClose()"
        class="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-xl transition-colors"
      >
        <fa-icon [icon]="faXmark" class="text-xl"></fa-icon>
      </button>
    </div>

    <!-- Body / Timeline -->
    <div class="flex-1 overflow-y-auto p-6 scrollbar-thin">
      @if (isLoading) {
        <div class="flex flex-col items-center justify-center py-20 gap-4">
          <div
            class="w-10 h-10 border-4 border-blue-500/20 border-t-blue-500 rounded-full animate-spin"
          ></div>
          <p class="text-gray-500 dark:text-gray-400 text-sm font-medium">Cargando actividad...</p>
        </div>
      } @else if (error) {
        <div class="flex flex-col items-center justify-center py-20 text-center">
          <div
            class="w-16 h-16 bg-red-100 dark:bg-red-900/30 text-red-500 rounded-full flex items-center justify-center mb-4"
          >
            <fa-icon [icon]="faCircleInfo" class="text-2xl"></fa-icon>
          </div>
          <h3 class="text-gray-900 dark:text-white font-semibold">Ha ocurrido un error</h3>
          <p class="text-gray-500 dark:text-gray-400 text-sm mt-1">{{ error }}</p>
          <button
            (click)="loadActivities()"
            class="mt-4 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium transition-colors"
          >
            Reintentar
          </button>
        </div>
      } @else if (activities.length === 0) {
        <div class="flex flex-col items-center justify-center py-20 text-center">
          <div
            class="w-16 h-16 bg-gray-100 dark:bg-gray-800 text-gray-400 rounded-full flex items-center justify-center mb-4"
          >
            <fa-icon [icon]="faClock" class="text-2xl"></fa-icon>
          </div>
          <h3 class="text-gray-900 dark:text-white font-semibold">Sin actividad reciente</h3>
          <p class="text-gray-500 dark:text-gray-400 text-sm mt-1">
            No se han registrado notas, llamadas o reuniones aún.
          </p>
        </div>
      } @else {
        <div
          class="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-gray-100 before:to-transparent dark:before:via-gray-800"
        >
          @for (activity of activities; track activity.id) {
            <div class="relative flex items-start gap-4">
              <!-- Icon Container -->
              <div
                class="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center z-10 shadow-sm transition-transform hover:scale-110"
                [ngClass]="getActivityColorClass(activity.type)"
              >
                <fa-icon [icon]="getActivityIcon(activity.type)"></fa-icon>
              </div>

              <!-- Content Card -->
              <div
                class="flex-1 min-w-0 bg-white dark:bg-gray-800/50 border border-gray-100 dark:border-gray-800 p-4 rounded-2xl shadow-sm hover:shadow-md transition-shadow"
              >
                <div class="flex items-center justify-between gap-4 mb-2">
                  <span class="text-xs font-bold uppercase tracking-wider opacity-60">{{
                    getActivityTypeLabel(activity.type)
                  }}</span>
                  <time class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1.5">
                    <fa-icon [icon]="faClock" class="text-[10px]"></fa-icon>
                    {{ activity.timestamp | date: 'dd MMM yyyy, HH:mm' }}
                  </time>
                </div>

                <h4 class="text-sm font-bold text-gray-900 dark:text-white mb-2 leading-tight">
                  {{ activity.title || 'Sin título' }}
                </h4>

                @if (isAdmin && activity.body) {
                  <div
                    class="activity-body text-sm text-gray-600 dark:text-gray-300 leading-relaxed overflow-hidden"
                    [innerHTML]="activity.body"
                  ></div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>

    <!-- Footer -->
    <div
      class="px-6 py-4 border-t border-gray-100 dark:border-gray-800 bg-gray-50/50 dark:bg-gray-800/50 flex justify-end"
    >
      <button
        (click)="onClose()"
        class="px-4 py-2 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300 rounded-xl text-sm font-bold hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors shadow-sm active:scale-95"
      >
        Cerrar
      </button>
    </div>
  </div>
</div>
